<!-- A cancellation's band is red whatever its stage: the design tints the record, not its status. -->
<app-slide-in-modal #modal size="xl" headerState="error" (closed)="onClosed()">
  <div
    class="layout-header w-100 d-flex justify-content-between align-items-center px-3"
    title
  >
    @if (details; as cancellation) {
      <app-details-header
        [displayId]="cancellation.displayId"
        [badges]="headerBadges"
        [customerName]="headerCustomerName"
        [customerDisplayId]="userProfile?.displayId ?? null"
        [accountType]="userProfile?.type ?? null"
        [isClient]="!!userProfile?.isClient"
      />
      <!-- Ending the request and removing it are both about the record, so both sit with its id. -->
      @if (callable) {
        <button
          type="button"
          class="lty-btn lty-btn-white cancellation-details__cancel"
          (click)="cancelModal.openModal(cancellation.id)"
          i18n
        >
          Annuler la résiliation
        </button>
      }
      <!-- Removing the record is about the record, so it sits with its id. -->
      @if (deletable) {
        <button
          type="button"
          class="lty-btn lty-btn-white"
          i18n-title
          title="Supprimer cette résiliation"
          (click)="deleteModal.openModal(cancellation.id)"
        >
          <app-trash-icon
            class="d-flex"
            height="20px"
            width="20px"
            color="var(--gray-500)"
          />
        </button>
      }
    }
  </div>

  <div class="d-flex align-items-stretch flex-column" body>
    @if (isLoading) {
      <div class="cancellation-details__loader">
        <app-spinner />
      </div>
    } @else if (notFound) {
      <div class="cancellation-details__empty" i18n>
        Cette résiliation est introuvable
      </div>
    } @else if (failed) {
      <div class="cancellation-details__empty" i18n>
        Impossible de charger cette résiliation
      </div>
    } @else if (details) {
      <div class="cancellation-details__notices">
        <app-cancellation-link-card
          target="basePolicy"
          [cancellation]="details"
          (changed)="onChanged($event)"
          (viewFlow)="openFlow($event)"
        />
        <app-cancellation-link-card
          target="replacement"
          [cancellation]="details"
          (changed)="onChanged($event)"
          (viewFlow)="openFlow($event)"
        />
        <app-cancellation-letter-card
          [cancellation]="details"
          (action)="
            (details.status === Status.SIGNED
              ? sendModal
              : details.status === Status.SENT
                ? finalizeModal
                : letterModal
            ).openModal(details)
          "
        />
      </div>

      <app-customer-profile-panel
        class="mt-16 d-block"
        [userProfile]="userProfile"
        [familyMemberName]="details.memberName"
        [insuranceType]="details.insuranceType"
      />

      <app-cancellation-request-info
        class="mt-12"
        (edit)="editModal.openModal($event)"
      />

      <app-cancellation-documents
        class="mt-12"
        (add)="documentModal.openModal($event)"
        (changed)="onChanged($event)"
      />

      <app-cancellation-log class="mt-12" />
    }
  </div>
</app-slide-in-modal>

<!-- The sheets opened from within the cancellation modal sit one layer above it. -->
<app-task-details #taskDetailsModal [layer]="1" (updated)="onFlowUpdated()" />
<app-cancellation-letter-modal
  #letterModal
  [layer]="1"
  (changed)="onChanged($event)"
/>
<app-cancellation-send-modal #sendModal (changed)="onChanged($event)" />
<app-cancellation-finalize-modal #finalizeModal (changed)="onChanged($event)" />
<app-cancellation-edit-modal
  #editModal
  [layer]="1"
  (changed)="onChanged($event)"
/>
<app-cancellation-delete-modal #deleteModal (deleted)="onDeleted()" />
<app-cancellation-cancel-modal #cancelModal (changed)="onChanged($event)" />
<app-cancellation-document-modal #documentModal (changed)="onChanged($event)" />
